module.exports = __webpack_public_path__ + "img/live_weixin.cba41f7f.png";